var default_styles_default = {
  "button_container": "-DU9A",
  "button_text": "JpuEb",
  "button_size_content": "bCL2W"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
